const howItWorksModalStyles = {
    container: `absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-[10px] max-w-[850px] w-full p-[25px] flex flex-col items-center shadow-lg bg-themeColor border-none`,
    closeButton: `absolute top-4 right-4 cursor-pointer`,
    innerContainer: `flex flex-col gap-[20px] `,
    heading: `text-center text-white text-[20px] font-[600] text-primary
              md:text-[25px]
    `,
    image: `w-full max-w-[650px] h-full object-cover rounded-[8px]`,
    note: `text-[12px] mt-[10px] leading-[18px]
           md:text-[18px]
    `,
    buttonContainer: `flex justify-end w-full`,
    skipButton: `!text-[13px] !font-[350] !py-[3px] 
                 md:!text-[17px] md:!py-[8px] md:w-[100px]
    `
};
export { howItWorksModalStyles };
